// src/directives/lazyload.js

const lazyLoadElements = [];

const loadImage = (el, binding) => {
    if (el.getAttribute('data-loaded') === 'true') {
        return; // Image has already been loaded, no need to load again
    }
    el.src = binding.value;
    el.setAttribute('data-loaded', 'true'); // Mark the image as loaded
};

const lazyLoadHandler = () => {
    lazyLoadElements.forEach(({ el, binding, observer }) => {
        if (el.getAttribute('data-loaded') !== 'true') {
            loadImage(el, binding);
            observer.unobserve(el);
        }
    });
  lazyLoadElements.length = 0; // 清空数组
};

export default {
    inserted: (el, binding) => {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadImage(el, binding);
                    observer.unobserve(el);
                }
            });
        });
    
        observer.observe(el);
        lazyLoadElements.push({ el, binding, observer });
    }
};

export { lazyLoadHandler };


// WEBPACK FOOTER //
// ./src/directives/lazyload.js